// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"dX-z","sponsoredTooltipWrapper":"eX-z","sponsoredTooltip":"fX-z","newCard":"gX-z"};